export const applyPhotographer = (params) => (
  $.ajax({
    type: "POST",
    url: "/photographers/apply",
    data: params
  })
)